import { reactRootErrorHandler } from './sentry'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'

createRoot(document.getElementById('root')!, {
  onUncaughtError: reactRootErrorHandler(),
  onCaughtError: reactRootErrorHandler(),
  onRecoverableError: reactRootErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
